import { getConciliationAccountDisplayNumber } from '../../utils/conciliationAccountDisplay'
import clsx from 'clsx'
import { Text } from '../ui'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { formatCurrency, formatDate } from '../../utils/formatter'
import { OrganizationAPI } from '../../../api/organization.api'
import GlobalContext from '../../../context/global-context'
import iconoEnlace from '../../../assets/iconos/iconEnlace.png'
import { bankIcons } from '../views/dashboard/Administracion/bancos/data'
import imgDefaultBank from '../../../assets/iconos/iconCasa.png'
import translations from '../ui/traslation/traslationAdministracion.json'
import { getPreviousYearConciliationRowKey, isPreviousYearConciliationLinkage } from '../../utils/normalizeConciliationLinkage'
import { getConciliationDisplayStatus } from '../../utils/conciliationStatus'

const TableCajaPrincipal = ({ onCheckboxChange, rows, idPrincipal, dataLinkage, setReloadData, resetSlider, dataModal,selectedBankFilter,origenSeleccionado,modalStatus,onCurrentData,setSelectedDataByOrigen,selectedDataByOrigen,
  selectedCheckboxes, setSelectedCheckboxes,selectedIds, setSelectedIds,getRowId,isInteracting,setIsInteracting,unselectedIds,setUnselectedIds}) => {
  const { ui, currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const [, setData] = useState({})
  const isCajaPrincipal = origenSeleccionado?.includes("caja") || origenSeleccionado?.includes("gestion")
  const [preselectedApplied, setPreselectedApplied] = useState(false);

const getUniversalId = (row) => {
  const gestionKey = getPreviousYearConciliationRowKey(row)
  if (gestionKey != null) return gestionKey;
  const candidates = row?._origen === 'gestion'
    ? [row.idPrincipal, row.realId, row.id, row.customId]
    : [row.realId, row.idPrincipal, row.id, row.customId]
  const value = candidates
    .find(candidate =>
      candidate != null && String(candidate).trim() !== '' && Number(candidate) !== 0
    )
  return value == null ? '' : String(value)
};


const cleanId = (id) => {
  if (typeof id === "number") return id;
  const match = String(id).match(/\d+/);
  return match ? Number(match[0]) : null;
};

const handleCheckboxToggle = (id, row, nextChecked) => {

  // --- 1) ID del checkbox (siempre el mismo)
  const checkboxId = getUniversalId(row);

let origen = row._origen;

if (!origen) {
  if (origenSeleccionado?.includes("gestion")) origen = "gestion";
  else if (origenSeleccionado?.includes("caja")) origen = "caja";
  else origen = "caja"; // valor por defecto seguro
}

  // --- 2) Para "Saldado año anterior", desvincular con idPrincipal.
  const realId = cleanId(
    origen === 'gestion'
      ? row.idPrincipal ?? getUniversalId(row)
      : getUniversalId(row)
  );


  // --- 4) Toggle visual
  setSelectedCheckboxes(prev => {
    const next = { ...prev }
    ;[checkboxId, row?.id, row?.idPrincipal, row?.realId]
      .filter(
        value => value != null && String(value).trim() !== '' && Number(value) !== 0
      )
      .forEach(value => {
        next[String(value)] = Boolean(nextChecked)
      })
    return next
  });

  const checked = Boolean(nextChecked);

  // --- 5) selectedIds → guarda ID del checkbox
  const currentIds = Array.isArray(selectedIds) ? selectedIds : []
  const nextIds = checked
    ? [...new Set([...currentIds, checkboxId])]
    : currentIds.filter(value => String(value) !== String(checkboxId))
  setSelectedIds(nextIds)
  onCheckboxChange(nextIds)

  // --- 6) selectedDataByOrigen → guarda el row completo
  setSelectedDataByOrigen(prev => {
    const arr = prev[origen] ?? [];
    return {
      ...prev,
      [origen]: checked
        ? [...arr, { ...row, _origen: origen }]
        : arr.filter(r => getUniversalId(r) !== checkboxId)
    };
  });

  // --- 7) unselectedIds → SOLO guarda realId para desvincular
  if (realId != null) {
    setUnselectedIds(prev => {
      const current = Array.isArray(prev) ? prev : []
      if (checked) {
        return current.filter(value => String(value) !== String(realId))
      }
      if (current.some(value => String(value) === String(realId))) return current
      return [...current, realId]
    });

  }
};

  const obtenerAbreviatura = nombre => { return translations.documentosContables[nombre] || nombre }

  const obtenerFechaActual = () => {
    const hoy = new Date()
    const dia = String(hoy.getDate()).padStart(2, '0')
    const mes = String(hoy.getMonth() + 1).padStart(2, '0')
    const anio = hoy.getFullYear()
    return `${anio}-${mes}-${dia}`
  }

  const linkageCaja = useMemo(() => { if (!dataModal?.linkage) return null; return dataModal.linkage.find(l => l.nombreCuentaBanco === 'Caja Principal') || null; }, [dataModal]); 
  const linkageGestion = useMemo(() => {
    if (!dataModal?.linkage) return null
    return dataModal.linkage.filter(isPreviousYearConciliationLinkage)
  }, [dataModal]);
  const isCobro = ['COBRADO', 'POR COBRAR', 'PARCIALMENTE COBRADO'].includes(modalStatus); 
  const isPago = ['PAGADO', 'POR PAGAR', 'PARCIALMENTE PAGADO'].includes(modalStatus); 
  const extraRow = useMemo(() => { if (!isCajaPrincipal || !dataModal) return null; 
    const origen = origenSeleccionado.includes('gestion') ? 'gestion' : 'caja'; if (origen === 'caja' && linkageCaja) { return { ...linkageCaja, customId: 'custom-caja-principal', checkboxId: linkageCaja.id, customRow: true, _origen: 'caja', }; } 
    if (origen === 'gestion' && linkageGestion?.length > 0) 
      { 
        const linkedRow = linkageGestion[0]
        const linkedAmount = Number(
          linkedRow?.montoEditable ??
          linkedRow?.montoRelacionado ??
          linkedRow?.montoTotal ??
          linkedRow?.monto ??
          linkedRow?.debe ??
          linkedRow?.haber ??
          0
        )
        return  { ...linkedRow,
          customId: 'custom-gestion-principal', 
          checkboxId: linkedRow.id,
          montoEditable: linkedAmount,
          montoAbono: isCobro ? linkedAmount : Number(linkedRow?.montoAbono ?? 0),
          montoCargo: isPago ? linkedAmount : Number(linkedRow?.montoCargo ?? 0),
          customRow: true,
           _origen: 'gestion', }; 
      } 
      return {
      id: origen === 'gestion'
        ? 'custom-gestion-principal'
        : 'custom-caja-principal',
      customId: origen === 'gestion'
        ? 'custom-gestion-principal'
        : 'custom-caja-principal',
      fecha: origen === 'gestion' ? 'Saldado año anterior' : obtenerFechaActual(),
      nombreCuentaBanco: 'Caja Principal',
      numeroCuentaBanco: '1-1-1-1',
      descripcion: `${isCobro ? 'Cobro' : 'Pago'} ${obtenerAbreviatura(
        dataModal.nombreCodigoDocumento
      )} ${dataModal.folio} ${dataModal.razonSocial}`,
      montoAbono: 0,
      montoCargo: 0,
      montoEditable: 0,
      status: 'PENDIENTE',
      customRow: true,
      _origen: origen,
    };

  }, [isCajaPrincipal, dataModal,isCobro, isPago,origenSeleccionado,linkageCaja, linkageGestion]);

useEffect(() => {
  if (preselectedApplied) return;   // ← evita el loop

  const origen = origenSeleccionado.includes('gestion') ? 'gestion' : 'caja';
  const rows = [];

  if (origen === "caja" && linkageCaja) rows.push(linkageCaja);
  if (origen === "gestion" && linkageGestion?.length > 0) rows.push(...linkageGestion);

  if (rows.length === 0) return;

  // Preselecciona 1 sola vez
  setSelectedCheckboxes(prev => {
    const next = { ...prev };
    rows.forEach(r => next[getUniversalId(r)] = true);
    return next;
  });

  setSelectedIds(
    Array.from(new Set([...(Array.isArray(selectedIds) ? selectedIds : []), ...rows.map(r => getUniversalId(r))]))
  );

  setSelectedDataByOrigen(prev => ({
    ...prev,
    [origen]: rows.map(r => ({ ...r, _origen: origen }))
  }));

  setPreselectedApplied(true);  // ← IMPORTANTE: evita volver a ejecutarlo

}, [
  linkageCaja?.id,
  linkageGestion?.length,
  origenSeleccionado.join(""), // no meter selectedCheckboxes aquí
]);

  useEffect(() => {
    if (isCajaPrincipal && !linkageCaja && !linkageGestion?.length) {
      setSelectedCheckboxes(prev => {
        const updated = { ...prev };
        delete updated["custom-caja-principal"];
        delete updated["custom-gestion-principal"];
        return updated;
      });
      setSelectedIds((Array.isArray(selectedIds) ? selectedIds : []).filter(
        id => id !== "custom-caja-principal" && id !== "custom-gestion-principal"
      ));
      onCheckboxChange(
        (Array.isArray(selectedIds) ? selectedIds : []).filter(
          id => id !== "custom-caja-principal" && id !== "custom-gestion-principal"
        )
      );
      onCurrentData([]);
    }
  }, [isCajaPrincipal, extraRow?.id]);

useEffect(() => {
  if (!extraRow || linkageCaja || linkageGestion?.length) return;

  const idsToSelect = [];
  const checkboxesToSet = {};

  if (origenSeleccionado.includes('caja')) {
    idsToSelect.push(extraRow.customId ?? extraRow.id);
    checkboxesToSet['custom-caja-principal'] = true;
  }
  if (origenSeleccionado.includes('gestion')) {
    idsToSelect.push(extraRow.customId ?? extraRow.id);
    checkboxesToSet['custom-gestion-principal'] = true;
  }

  const alreadySelected = idsToSelect.every(id => selectedCheckboxes[id]);
  const alreadyUnselected = idsToSelect.every(id => selectedCheckboxes[id] === false);

  // 👇 Solo aplica si el usuario no lo desmarcó manualmente
  if (!alreadySelected && !alreadyUnselected && idsToSelect.length > 0) {
    setSelectedCheckboxes(prev => ({ ...prev, ...checkboxesToSet }));
    setSelectedIds(Array.from(new Set([...(Array.isArray(selectedIds) ? selectedIds : []), ...idsToSelect])));
    onCheckboxChange(idsToSelect);
    onCurrentData([extraRow], origenSeleccionado.includes('gestion') ? 'gestion' : 'caja')
    setSelectedDataByOrigen(prev => ({
      ...prev,
      [origenSeleccionado.includes('gestion') ? 'gestion' : 'caja']: [extraRow],
    }))
  }
}, [isCajaPrincipal, extraRow?.id, origenSeleccionado, selectedCheckboxes]);

useEffect(() => {
  if (!extraRow) return;

  const origen = origenSeleccionado.includes('gestion') ? 'gestion' : 'caja';

  setSelectedDataByOrigen(prev => {
    const current = prev[origen] || [];
    // Reemplaza o agrega el extraRow sincronizado
    const exists = current.some(r => r.id === extraRow.id);
    const updated = exists
      ? current.map(r => (r.id === extraRow.id ? extraRow : r))
      : [...current, extraRow];
    return { ...prev, [origen]: updated };
  });
}, [extraRow?.montoEditable, extraRow?.id]);


  const styles = {
    wrapper: 'overflow-x-auto rounded-3xl shadow-sm',
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight',
    thead: 'sticky top-0 z-10 bg-gray-50',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-400 font-medium',
  }

  const orderableCols = [
    { col: '', field: null },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Cuenta Corriente', field: 'cuentaCorriente' },
    { col: 'Descripción', field: 'descripción' },
    { col: 'Abono', field: 'abono' },
    { col: 'Cargo', field: 'cargo' },
    { col: 'Status', field: 'status' },
    { col: '', field: null},
  ]

  const sortRows = useCallback(() => {
  if (isCajaPrincipal && extraRow) return [extraRow]

  if (!Array.isArray(rows)) return []

  if (dataLinkage && dataLinkage.length > 0) {
    const match = rows.find(row => row.comprobante === dataLinkage[0].comprobante)
    return match ? [match] : []
  }

  return rows
}, [isCajaPrincipal, extraRow, rows, dataLinkage])

  useEffect(() => {
    if (isCajaPrincipal) return; // 🚨 No inicializar desde rows si es caja/gestion
    const newSelection = {}
    let hasChanges = false
    rows.forEach((item) => {
      const shouldBeSelected =
        item.seleccionado === true ||
        (item.linkage && dataLinkage && item.linkage.idPrincipal === dataLinkage.idPrincipal)
      if (shouldBeSelected) {
        newSelection[item.id] = true
        hasChanges = true
      }
    })
    if (hasChanges && Object.keys(selectedCheckboxes).length === 0) {
    setSelectedCheckboxes(newSelection)
    const selected = Object.keys(newSelection)
    setSelectedIds(selected)
    onCheckboxChange(selected)
    const selectedData = rows.filter(row => selected.includes(row.id))
    const origenForzado = origenSeleccionado.includes('gestion') ? 'gestion' : 'caja';
    onCurrentData(selectedData, origenForzado)
  }
  }, [rows, dataLinkage, isCajaPrincipal])
  
  const handleDesvincular = async (ids = selectedIds) => {
    const numericIds = Array.from(
      new Set(
        (Array.isArray(ids) ? ids : [])
          .map(Number)
          .filter(Number.isFinite)
      )
    )
    if (numericIds.length === 0) return
    const payload = { ids: numericIds }
    try {
    ui.setLoader({ visible: true})
    const response = await organizationAPI.postDesvincular({
        businessId: currentBusiness.id, 
        idLibro: idPrincipal,
    }, payload)
    setData(response)
    setSelectedCheckboxes({})
    setSelectedIds([])
    if (setReloadData) setReloadData(prev => !prev)
    } catch (error) {
    console.error(error)
    } finally {
      ui.setLoader({ visible: false})
    }
  }

const prepareRow = (item) => ({
   ...item,
   checkboxId: item.checkboxId ?? item.customId ?? item.id,
   realId:
     item.idPrincipal != null && Number(item.idPrincipal) !== 0
       ? item.idPrincipal
       : item.id ?? null,
});


const getCleanStatus = row =>
    typeof row?.status === 'string'
      ? row.status.replace(/\s*undefined\s*/gi, '').trim()
      : ''

const normalizeStatus = status =>
    String(status || '')
      .replace(/\s*undefined\s*/gi, '')
      .trim()
      .toUpperCase()

  const getDisplayDescription = row => {
    const baseDescription = row?.descripcion || row?.glosa || ''
    const normalizedDescription = String(baseDescription).trim().toLowerCase()

    if (normalizedDescription.startsWith('pago comprobante')) {
      if (row?.tipoMovimiento === 'abono') return 'Cobro masivo vinculacion'
      if (row?.tipoMovimiento === 'cargo') return 'Pago masivo vinculacion'
    }

    return baseDescription
  }

  const statusTone = status => {
    const s = normalizeStatus(status)
    if (s.includes('PARCIAL')) return 'warning'
    if (s.includes('CONCILIADO') || s.includes('PAGADO') || s.includes('COBRADO')) return 'success'
    if (s.includes('PENDIENTE')) return 'danger'
    if (s.includes('PARCIAL') && s.includes('ANUL')) return 'muted'
    return 'muted'
  }

  const statusBadgeClass = status => {
    const tone = statusTone(status)
    return clsx(
      'inline-flex items-center justify-center px-3 py-1 rounded-full text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider',
      {
        'text-danger bg-danger/10': tone === 'danger',
        'text-success bg-success/10': tone === 'success',
        'text-amber-700 bg-amber-100': tone === 'warning',
        'text-muted bg-border/40': tone === 'muted'
      }
    )
  }

  if (!rows?.[0] && !isCajaPrincipal) {
  return <Text className='grid place-items-center py-12'>{translations.tableAction.noData}</Text>
  }

  if (isCajaPrincipal) {
    // Tabla simplificada sin filtros ni paginación
    return (
      <div className="flex flex-col h-full">
        <div className="flex-1">
          <div className={clsx(styles.wrapper, 'max-h-96 overflow-y-auto mt-2')}>
            <table className={styles.table}>
              <thead className={styles.thead}>
                <tr>
                  {orderableCols.map(({ col }, i) => (
                    <th key={i} className={clsx(styles.th, i === 0 && styles.mediumCol)}>
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className={styles.tbody}>
                {sortRows()?.map((rawItem) => {
                  const item = prepareRow(rawItem) 
                  const isChecked = !!selectedCheckboxes[item.id] 
                  const isSeleccionado = item.seleccionado === true 
                  const isActive = isChecked || isSeleccionado 
                  const universalId = getUniversalId(item)
                  const pendingUnlinkId = item?._origen === 'gestion'
                    ? cleanId(item?.idPrincipal ?? universalId)
                    : cleanId(universalId)
                  const isPendingUnlink = (unselectedIds || []).some(
                    id => String(id) === String(pendingUnlinkId)
                  )
                  const hasExplicitCheckboxState = Object.prototype.hasOwnProperty.call(
                    selectedCheckboxes,
                    universalId
                  )
                  const isInitiallyLinked =
                    item?._origen === 'gestion' && (linkageGestion?.length ?? 0) > 0
                  const isTableChecked = hasExplicitCheckboxState
                    ? selectedCheckboxes[universalId] === true
                    : item.seleccionado === true || isInitiallyLinked
                  const isCustom = item.customRow 
                  const origen = item._origen || (origenSeleccionado.includes('gestion') ? 'gestion' : 'caja'); 
                  const currentRows = selectedDataByOrigen[origen] || []; 
                  const selectedItem = currentRows.find(r => r.id === item.id) || item;
                  const cleanStatus = getCleanStatus(item)
                  const displayStatus = getConciliationDisplayStatus(cleanStatus, modalStatus, isChecked)
                  return (
                    <tr key={item.id} className={styles.tr}>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <div className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            className='rounded'
                            checked={!isPendingUnlink && isTableChecked}
                            onChange={event =>
                              handleCheckboxToggle(universalId, item, event.target.checked)
                            }
                          />
                          <img src={bankIcons[item.nombreCuentaBanco] || imgDefaultBank} className="min-w-8 h-8" />
                        </div>
                      </td>
                      <td className={clsx(styles.td, styles.smallCol)}>
                        <Text className={styles.boldText}>
                          {item.customRow && item._origen === 'gestion'
                            ? 'Saldado año anterior'
                            : formatDate(item.fecha)}
                        </Text>
                      </td>
                      <td className={clsx(styles.td, styles.wideCol)}>
                        <Text className={styles.boldText}>{item.nombreCuentaBanco}</Text>
                        <Text className={styles.text}>{getConciliationAccountDisplayNumber(item, item.numeroCuentaBanco)}</Text>
                      </td>
                      <td className={clsx(styles.td, styles.wideCol)}>
                        <Text className={styles.boldText}>{getDisplayDescription(item)}</Text>
                      </td>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        {selectedItem.customRow && isCobro ? (
                          <input
                            type="text"
                            inputMode="numeric"
                            className="border rounded-full text-xs text-right px-1 py-0.5 w-20
                              [appearance:textfield]
                              [&::-webkit-outer-spin-button]:appearance-none
                              [&::-webkit-inner-spin-button]:appearance-none"
                            // mostramos montoEditable para permitir edición en el modal/tbl; si no existe, mostramos montoAbono o 0
                            value={`$ ${Number(selectedItem.montoEditable ?? selectedItem.montoAbono ?? item.debe ?? 0).toLocaleString('es-CL')}`}
                            onFocus={e => {
                              // al enfocar mostramos el número crudo para editar
                              e.target.value = String(selectedItem.montoEditable ?? selectedItem.montoAbono ?? 0)
                            }}
                            onBlur={e => {
                              // formatea al perder foco (opcional)
                              const digits = e.target.value.replace(/[^\d]/g, '');
                              e.target.value = `$ ${Number(digits || 0).toLocaleString('es-CL')}`
                            }}
                            onChange={e => {
                              const digits = e.target.value.replace(/[^\d]/g, '');
                              const hasValue = digits.length > 0;
                              const newValue = Number(digits || 0);
                              const origen = selectedItem._origen;
                              const manualLinkedId = cleanId(
                                selectedItem.idPrincipal ??
                                  selectedItem.realId ??
                                  selectedItem.id ??
                                  item?.idPrincipal ??
                                  item?.realId ??
                                  item?.id
                              )

                              setSelectedDataByOrigen(prev => {
                                const current = prev[origen] || [];
                                const updated = current.map(r => {
                                  if (r.id !== selectedItem.id) return r
                                  const nextRow = {
                                    ...r,
                                    montoEditable: newValue,
                                    montoAbono: newValue,
                                    montoCargo: 0
                                  }
                                  if (origen === 'caja') {
                                    nextRow._manualCajaMonto = hasValue ? newValue : null
                                    nextRow._manualLinkedId = hasValue ? manualLinkedId : null
                                  }
                                  return nextRow
                                })
                                return { ...prev, [origen]: updated }
                              })
                            }}
                          />
                        ) : (
                          <Text className={styles.boldText}>{formatCurrency(selectedItem.montoAbono)}</Text>
                        )}
                      </td>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        {selectedItem.customRow && isPago ? (
                          <input
                            type="text"
                            inputMode="numeric"
                            className="border rounded-full text-xs text-right px-1 py-0.5 w-20
                              [appearance:textfield]
                              [&::-webkit-outer-spin-button]:appearance-none
                              [&::-webkit-inner-spin-button]:appearance-none"
                            value={`$ ${Number(selectedItem.montoEditable ?? selectedItem.montoCargo ?? item.haber ?? 0).toLocaleString('es-CL')}`}
                            onFocus={e => {
                              e.target.value = String(selectedItem.montoEditable ?? selectedItem.montoCargo ?? 0)
                            }}
                            onBlur={e => {
                              const digits = e.target.value.replace(/[^\d]/g, '');
                              e.target.value = `$ ${Number(digits || 0).toLocaleString('es-CL')}`
                            }}
                            onChange={e => {
                              const digits = e.target.value.replace(/[^\d]/g, '');
                              const hasValue = digits.length > 0;
                              const newValue = Number(digits || 0);
                              const origen = selectedItem._origen;
                              const manualLinkedId = cleanId(
                                selectedItem.idPrincipal ??
                                  selectedItem.realId ??
                                  selectedItem.id ??
                                  item?.idPrincipal ??
                                  item?.realId ??
                                  item?.id
                              )

                              setSelectedDataByOrigen(prev => {
                                const current = prev[origen] || [];
                                const updated = current.map(r => {
                                  if (r.id !== selectedItem.id) return r
                                  const nextRow = {
                                    ...r,
                                    montoEditable: newValue,
                                    montoCargo: newValue,
                                    montoAbono: 0
                                  }
                                  if (origen === 'caja') {
                                    nextRow._manualCajaMonto = hasValue ? newValue : null
                                    nextRow._manualLinkedId = hasValue ? manualLinkedId : null
                                  }
                                  return nextRow
                                })
                                return { ...prev, [origen]: updated }
                              })
                            }}
                          />
                        ) : (
                          <Text className={styles.boldText}>{formatCurrency(selectedItem.montoCargo)}</Text>
                        )}
                      </td>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <span className={statusBadgeClass(displayStatus)}>
                          {displayStatus || '—'}
                        </span>
                      </td>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        {!isCustom && (
                          <div className='flex h-full items-center justify-center space-x-3'>
                            <div
                              className={clsx(
                                'flex flex-col text-xs items-center justify-center',
                                !isActive ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:cursor-pointer'
                              )}
                              onClick={() => {
                                if (isActive) {
                                  handleDesvincular([item.realId ?? item.idPrincipal ?? item.id])
                                }
                              }}
                            >
                              <div
                                className={clsx(
                                  'bg-[#fff] flex shadow-full-xs rounded-full items-center justify-center w-9 h-9 transition-colors duration-150',
                                  isActive
                                    ? 'text-slate-400 hover:bg-slate-100/50'
                                    : 'bg-gray-100 text-gray-300'
                                )}
                              >
                                <img src={iconoEnlace} alt="icono enlace" className="w-7 h-7" />
                              </div>
                              <Text className='mt-2'>Desconciliar</Text>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

}

export default TableCajaPrincipal
